import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationItem } from '../../interfaces/navigation-items';
import { PlatformService } from '../platform-service/platform.service';
import { CurrentNavigationItemService } from './current-navigation-item.service';

@Injectable({
  providedIn: 'root',
})
export class NavigationItemVisibilityService {
  constructor(
    private router: Router,
    private platformService: PlatformService,
    private currentNavigationItemService: CurrentNavigationItemService,
  ) {}

  public isNavigationItemHidden(_navigationItem: NavigationItem): boolean {
    const minW = _navigationItem.hideBelowViewportWidth;
    const hiddenByViewport =
      (minW ?? 0) > 0 &&
      (window.visualViewport?.width ?? window.innerWidth) < minW!;

    return (
      (_navigationItem.hideOnOtherNavigationItems?.includes(
        this.currentNavigationItemService.currentNavigationItem(),
      ) ??
        false) ||
      ((_navigationItem.hideOnMobile ?? false) &&
        this.platformService.isMobile()) ||
      hiddenByViewport
    );
  }

  public isContainingVisibleChildren(_navigationItem: NavigationItem): boolean {
    return (
      (_navigationItem.children?.filter((_navItem) => !this.isNavigationItemHidden(_navItem))
        .length ?? 0) > 0
    );
  }
}
